import React, { useState, useEffect, useReducer, useContext } from "react";
import { toast } from "react-toastify";

import { useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Chip from "@material-ui/core/Chip";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";

import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import EditIcon from "@material-ui/icons/Edit";
import PeopleIcon from "@material-ui/icons/People";
import DownloadIcon from "@material-ui/icons/GetApp";
import AddIcon from "@material-ui/icons/Add";
import ListAltIcon from "@material-ui/icons/ListAlt";

import MainHeader from "../../components/MainHeader";

import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import TableRowSkeleton from "../../components/TableRowSkeleton";
import ContactListDialog from "../../components/ContactListDialog";
import ConfirmationModal from "../../components/ConfirmationModal";
import toastError from "../../errors/toastError";
import { Grid } from "@material-ui/core";

import planilhaExemplo from "../../assets/planilha.xlsx";
// import { SocketContext } from "../../context/Socket/SocketContext";
import { AuthContext } from "../../context/Auth/AuthContext";

const reducer = (state, action) => {
  if (action.type === "LOAD_CONTACTLISTS") {
    const contactLists = action.payload;
    const newContactLists = [];

    contactLists.forEach((contactList) => {
      const contactListIndex = state.findIndex((u) => u.id === contactList.id);
      if (contactListIndex !== -1) {
        state[contactListIndex] = contactList;
      } else {
        newContactLists.push(contactList);
      }
    });

    return [...state, ...newContactLists];
  }

  if (action.type === "UPDATE_CONTACTLIST") {
    const contactList = action.payload;
    const contactListIndex = state.findIndex((u) => u.id === contactList.id);

    if (contactListIndex !== -1) {
      state[contactListIndex] = contactList;
      return [...state];
    } else {
      return [contactList, ...state];
    }
  }

  if (action.type === "DELETE_CONTACTLIST") {
    const contactListId = action.payload;

    const contactListIndex = state.findIndex((u) => u.id === contactListId);
    if (contactListIndex !== -1) {
      state.splice(contactListIndex, 1);
    }
    return [...state];
  }

  if (action.type === "RESET") {
    return [];
  }
};

const useStyles = makeStyles((theme) => ({
  pageRoot: {
    flex: 1,
    width: "100%",
    maxWidth: "100%",
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1),
    },
  },
  pageHeader: {
    width: "100%",
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    borderRadius: 16,
    color: "#1e2a44",
    background: "#EDF4FF",
    boxShadow: "0 8px 20px rgba(15, 23, 42, 0.06)",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1.5),
    },
  },
  pageHeaderTitle: {
    fontWeight: 600,
    letterSpacing: 0.1,
    fontSize: "1.2rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.05rem",
    },
  },
  pageHeaderSubtitle: {
    marginTop: theme.spacing(0.25),
    color: "rgba(30,42,68,0.78)",
    fontSize: "0.8rem",
    lineHeight: 1.35,
  },
  headerChip: {
    backgroundColor: "#EAF1FF",
    color: "#2f4b7c",
    border: "1px solid #d7e5ff",
    fontWeight: 500,
    fontSize: "0.72rem",
    height: 24,
  },
  controlsPaper: {
    marginBottom: theme.spacing(2),
    borderRadius: 14,
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: "0 8px 22px rgba(15, 23, 42, 0.08)",
    padding: theme.spacing(1.25),
    backgroundColor: theme.palette.background.paper,
  },
  searchField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      backgroundColor: theme.palette.background.default,
    },
    "& .MuiInputBase-input": {
      fontSize: "0.82rem",
      paddingTop: 13,
      paddingBottom: 13,
    },
  },
  actionButton: {
    minHeight: 42,
    borderRadius: 10,
    fontWeight: 600,
    fontSize: "0.75rem",
    padding: theme.spacing(0.8, 1.4),
    boxShadow: "0 6px 14px rgba(7, 64, 171, 0.14)",
  },
  mainPaper: {
    flex: 1,
    overflowY: "auto",
    ...theme.scrollbarStyles,
    borderRadius: 14,
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: "0 12px 26px rgba(17, 24, 39, 0.09)",
  },
  tableHeaderCell: {
    fontWeight: 700,
    color: theme.palette.text.secondary,
    backgroundColor:
      theme.palette.type === "dark"
        ? "rgba(255,255,255,0.04)"
        : "rgba(15, 23, 42, 0.03)",
    fontSize: "0.76rem",
  },
  tableRow: {
    transition: "background-color 0.2s ease",
    "&:hover": {
      backgroundColor:
        theme.palette.type === "dark"
          ? "rgba(255,255,255,0.03)"
          : "rgba(15, 23, 42, 0.035)",
    },
  },
  tableCellText: {
    fontSize: "0.78rem",
  },
  actionCell: {
    minWidth: 170,
  },
  actionIconButton: {
    border: `1px solid ${theme.palette.divider}`,
    margin: theme.spacing(0, 0.2),
  },

  premiumRoot: {
    width: "100%",
    maxWidth: "100%",
    minHeight: "100%",
    height: "auto",
    overflowX: "hidden",
    overflowY: "auto",
    WebkitOverflowScrolling: "touch",
    boxSizing: "border-box",
    padding: theme.spacing(2),
    paddingBottom: theme.spacing(7),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1.5),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1),
      paddingBottom: theme.spacing(8)
    }
  },
  premiumHero: {
    position: "relative",
    overflow: "visible",
    borderRadius: 24,
    padding: theme.spacing(2.1),
    background: "linear-gradient(135deg, #071B4D 0%, #005BFF 58%, #00A3FF 100%)",
    color: "#fff",
    boxShadow: "0 24px 58px rgba(0,102,255,0.22)",
    display: "grid",
    gridTemplateColumns: "1fr 360px",
    gap: theme.spacing(2),
    alignItems: "center",
    [theme.breakpoints.down("md")]: { gridTemplateColumns: "1fr" },
    [theme.breakpoints.down("sm")]: {
      borderRadius: 20,
      padding: theme.spacing(1.6)
    }
  },
  premiumHeroLeft: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    minWidth: 0
  },
  premiumHeroIcon: {
    width: 58,
    height: 58,
    borderRadius: 18,
    background: "rgba(255,255,255,.16)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 26,
    flexShrink: 0
  },
  premiumHeroTitle: {
    fontWeight: 950,
    fontSize: "1.65rem",
    lineHeight: 1.08,
    color: "#fff",
    [theme.breakpoints.down("sm")]: { fontSize: "1.25rem" }
  },
  premiumHeroSubtitle: {
    fontSize: ".84rem",
    opacity: .86,
    marginTop: 6,
    lineHeight: 1.45,
    [theme.breakpoints.down("sm")]: { fontSize: ".74rem" }
  },
  premiumMetrics: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: theme.spacing(1)
  },
  premiumMetric: {
    borderRadius: 18,
    padding: theme.spacing(1.3),
    background: "rgba(255,255,255,.14)",
    border: "1px solid rgba(255,255,255,.20)"
  },
  premiumMetricValue: {
    fontWeight: 950,
    fontSize: "1.2rem",
    color: "#fff"
  },
  premiumMetricLabel: {
    fontSize: ".68rem",
    opacity: .78,
    fontWeight: 800,
    marginTop: 3
  },
  premiumControls: {
    borderRadius: 22,
    padding: theme.spacing(1.4),
    background: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: "0 12px 28px rgba(15,23,42,0.06)",
    display: "grid",
    gridTemplateColumns: "1fr 220px",
    gap: theme.spacing(1),
    [theme.breakpoints.down("sm")]: { gridTemplateColumns: "1fr" }
  },
  premiumSearch: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 14,
      fontSize: ".84rem",
      background: theme.palette.type === "dark" ? "rgba(255,255,255,.04)" : "#F8FAFC",
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#0066FF" }
    }
  },
  listsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
    gap: theme.spacing(1.3),
    [theme.breakpoints.down("sm")]: { gridTemplateColumns: "1fr" }
  },
  listCard: {
    borderRadius: 24,
    padding: theme.spacing(1.6),
    border: `1px solid ${theme.palette.divider}`,
    background: theme.palette.type === "dark" ? "rgba(255,255,255,0.04)" : "#FFFFFF",
    boxShadow: "0 14px 30px rgba(15,23,42,0.07)"
  },
  listTop: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: theme.spacing(1)
  },
  listNameRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    minWidth: 0
  },
  listAvatar: {
    width: 44,
    height: 44,
    borderRadius: 15,
    background: "linear-gradient(135deg,#0066FF,#00A3FF)",
    color: "#fff",
    fontWeight: 950,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0
  },
  listName: {
    fontWeight: 950,
    fontSize: ".96rem",
    color: theme.palette.type === "dark" ? "#fff" : "#0F172A",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  listMeta: {
    fontSize: ".74rem",
    color: "#64748B",
    marginTop: 3
  },
  listActions: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: theme.spacing(.8),
    marginTop: theme.spacing(1.4)
  },
  listActionBtn: {
    borderRadius: 12,
    minWidth: 0,
    padding: "8px 4px",
    border: "1px solid rgba(0,102,255,.16)",
    background: theme.palette.type === "dark" ? "rgba(255,255,255,.04)" : "#F8FAFC",
    color: "#0066FF",
    cursor: "pointer",
    fontWeight: 900,
    fontSize: ".68rem",
    textAlign: "center",
    textDecoration: "none"
  },
  emptyPremium: {
    borderRadius: 24,
    padding: theme.spacing(5),
    textAlign: "center",
    background: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    color: "#94A3B8",
    fontWeight: 900
  }

}));

const ContactLists = () => {
  const classes = useStyles();
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [selectedContactList, setSelectedContactList] = useState(null);
  const [deletingContactList, setDeletingContactList] = useState(null);
  const [contactListModalOpen, setContactListModalOpen] = useState(false);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [searchParam, setSearchParam] = useState("");
  const [contactLists, dispatch] = useReducer(reducer, []);
  //   const socketManager = useContext(SocketContext);
  const { user, socket } = useContext(AuthContext);


  useEffect(() => {
    dispatch({ type: "RESET" });
    setPageNumber(1);
  }, [searchParam]);

  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchContactLists = async () => {
        try {
          const { data } = await api.get("/contact-lists/", {
            params: { searchParam, pageNumber },
          });
          dispatch({ type: "LOAD_CONTACTLISTS", payload: data.records });
          setHasMore(data.hasMore);
          setLoading(false);
        } catch (err) {
          toastError(err);
        }
      };
      fetchContactLists();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchParam, pageNumber]);

  useEffect(() => {
    const companyId = user.companyId;
    // const socket = socketManager.GetSocket();

    const onContactListEvent = (data) => {
      if (data.action === "update" || data.action === "create") {
        dispatch({ type: "UPDATE_CONTACTLIST", payload: data.record });
      }

      if (data.action === "delete") {
        dispatch({ type: "DELETE_CONTACTLIST", payload: +data.id });
      }
    };

    socket.on(`company-${companyId}-ContactList`, onContactListEvent);

    return () => {
      socket.off(`company-${companyId}-ContactList`, onContactListEvent);
    };
  }, [socket, user.companyId]);

  const handleOpenContactListModal = () => {
    setSelectedContactList(null);
    setContactListModalOpen(true);
  };

  const handleCloseContactListModal = () => {
    setSelectedContactList(null);
    setContactListModalOpen(false);
  };

  const handleSearch = (event) => {
    setSearchParam(event.target.value.toLowerCase());
  };

  const handleEditContactList = (contactList) => {
    setSelectedContactList(contactList);
    setContactListModalOpen(true);
  };

  const handleDeleteContactList = async (contactListId) => {
    try {
      await api.delete(`/contact-lists/${contactListId}`);
      toast.success(i18n.t("contactLists.toasts.deleted"));
    } catch (err) {
      toastError(err);
    }
    setDeletingContactList(null);
    setSearchParam("");
    setPageNumber(1);
  };

  const loadMore = () => {
    setPageNumber((prevState) => prevState + 1);
  };

  const handleScroll = (e) => {
    if (!hasMore || loading) return;
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (scrollHeight - (scrollTop + 100) < clientHeight) {
      loadMore();
    }
  };

  const goToContacts = (id) => {
    history.push(`/contact-lists/${id}/contacts`);
  };

  return (
    <div className={classes.pageRoot}>
      <ConfirmationModal
        title={
          deletingContactList &&
          `${i18n.t("contactLists.confirmationModal.deleteTitle")} ${deletingContactList.name
          }?`
        }
        open={confirmModalOpen}
        onClose={setConfirmModalOpen}
        onConfirm={() => handleDeleteContactList(deletingContactList.id)}
      >
        {i18n.t("contactLists.confirmationModal.deleteMessage")}
      </ConfirmationModal>
      <ContactListDialog
        open={contactListModalOpen}
        onClose={handleCloseContactListModal}
        aria-labelledby="form-dialog-title"
        contactListId={selectedContactList && selectedContactList.id}
      />
      <div className={classes.premiumRoot}>
        <section className={classes.premiumHero}>
          <div className={classes.premiumHeroLeft}>
            <div className={classes.premiumHeroIcon}>👥</div>
            <div style={{ minWidth: 0 }}>
              <Typography className={classes.premiumHeroTitle}>
                Listas de Contatos
              </Typography>
              <Typography className={classes.premiumHeroSubtitle}>
                Organize bases, segmentos e públicos para campanhas mais eficientes e seguras.
              </Typography>
            </div>
          </div>

          <div className={classes.premiumMetrics}>
            <div className={classes.premiumMetric}>
              <Typography className={classes.premiumMetricValue}>{contactLists.length}</Typography>
              <Typography className={classes.premiumMetricLabel}>Listas</Typography>
            </div>
            <div className={classes.premiumMetric}>
              <Typography className={classes.premiumMetricValue}>
                {contactLists.reduce((acc, item) => acc + Number(item.contactsCount || 0), 0)}
              </Typography>
              <Typography className={classes.premiumMetricLabel}>Contatos</Typography>
            </div>
          </div>
        </section>

        <div className={classes.premiumControls}>
          <TextField
            fullWidth
            placeholder={i18n.t("contacts.searchPlaceholder")}
            type="search"
            value={searchParam}
            onChange={handleSearch}
            variant="outlined"
            className={classes.premiumSearch}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon style={{ color: "#0066FF" }} />
                </InputAdornment>
              ),
            }}
          />
          <Button
            fullWidth
            variant="contained"
            color="primary"
            onClick={handleOpenContactListModal}
            className={classes.actionButton}
            startIcon={<AddIcon />}
            style={{ borderRadius: 14, fontWeight: 900, textTransform: "none" }}
          >
            Nova lista
          </Button>
        </div>

        <div className={classes.listsGrid} onScroll={handleScroll}>
          {contactLists.map((contactList) => (
            <div key={contactList.id} className={classes.listCard}>
              <div className={classes.listTop}>
                <div className={classes.listNameRow}>
                  <div className={classes.listAvatar}>📂</div>
                  <div style={{ minWidth: 0 }}>
                    <Typography className={classes.listName}>{contactList.name}</Typography>
                    <Typography className={classes.listMeta}>
                      {contactList.contactsCount || 0} contato{Number(contactList.contactsCount || 0) !== 1 ? "s" : ""}
                    </Typography>
                  </div>
                </div>
                <Chip
                  label="Lista"
                  size="small"
                  style={{
                    fontWeight: 900,
                    fontSize: ".68rem",
                    height: 24,
                    background: "rgba(0,102,255,.08)",
                    color: "#0066FF",
                    border: "1px solid rgba(0,102,255,.18)"
                  }}
                />
              </div>

              <div className={classes.listActions}>
                <a href={planilhaExemplo} download="planilha.xlsx" className={classes.listActionBtn}>
                  Baixar
                </a>
                <button className={classes.listActionBtn} onClick={() => goToContacts(contactList.id)}>
                  Contatos
                </button>
                <button className={classes.listActionBtn} onClick={() => handleEditContactList(contactList)}>
                  Editar
                </button>
                <button
                  className={classes.listActionBtn}
                  style={{ color: "#EF4444", borderColor: "rgba(239,68,68,.20)" }}
                  onClick={() => {
                    setConfirmModalOpen(true);
                    setDeletingContactList(contactList);
                  }}
                >
                  Excluir
                </button>
              </div>
            </div>
          ))}

          {loading && <TableRowSkeleton columns={1} />}

          {contactLists.length === 0 && !loading && (
            <div className={classes.emptyPremium}>Nenhuma lista encontrada.</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactLists;
